import { TradeIn } from '@upstart/harmony/lib/legos/dealTypes';
import { fmtMoney } from '@upstart/harmony/lib/formatter';
import { Button, Col, Row } from 'react-bootstrap';
import React from 'react';
import { MailingAddress } from '@upstart/harmony/lib/legos/payoffTypes';
import { filterAndJoinStrings } from '../../../util/utils';

export const TradePayoffResults = (props: {
  tradeIn?: TradeIn;
  onClose: () => void;
  successButtonText?: string;
}) => {
  const NA = 'N/A';

  const fmtAddress = (address: MailingAddress) => {
    const city = address.city ? `${address.city},` : '';
    const cityStateZip = filterAndJoinStrings(
      [city, address.state, address.zipCode],
      ' ',
    ).trim();

    return (
      <>
        {address.company && <div>{address.company}</div>}
        {address.attn && <div>Attn: {address.attn}</div>}
        {address.streetAddress && <div>{address.streetAddress}</div>}
        {address.streetAddress2 && <div>{address.streetAddress2}</div>}
        <div>{cityStateZip}</div>
      </>
    );
  };

  const sections = [
    {
      rows: [
        {
          columns: [
            {
              label: 'Payoff Amount',
              value: props.tradeIn?.payOff
                ? fmtMoney(Number(props.tradeIn?.payOff), 2)
                : NA,
            },
            {
              label: 'Valid Through',
              value: props.tradeIn?.payoffExpiredDate ?? NA,
            },
          ],
        },
        {
          columns: [
            {
              label: 'Per Diem',
              value: props.tradeIn?.perDiem
                ? fmtMoney(props.tradeIn.perDiem, 2)
                : NA,
            },
          ],
        },
      ],
    },
    {
      rows: [
        {
          columns: [
            {
              label: 'Owner Name',
              value: props.tradeIn?.payoffMeta?.ownerName ?? NA,
            },
            {
              label: 'Account Number',
              value: props.tradeIn?.payoffMeta?.accountNumber ?? NA,
            },
          ],
        },
        {
          columns: [
            {
              label: 'Co-Owner Name',
              value: props.tradeIn?.payoffMeta?.coOwnerName ?? NA,
            },
          ],
        },
      ],
    },
    {
      rows: [
        {
          columns: [
            {
              label: 'Lender Phone Number',
              value: props.tradeIn?.payoffMeta?.lenderPhoneNumber ?? NA,
            },
          ],
        },
        {
          columns: [
            {
              label: 'Check Payable To',
              value: props.tradeIn?.payoffMeta?.checkPayableTo ?? NA,
            },
          ],
        },
        {
          columns: [
            {
              label: 'Standard Mailing Address',
              value: props.tradeIn?.payoffMeta?.standardMailingAddress
                ? fmtAddress(props.tradeIn.payoffMeta.standardMailingAddress)
                : NA,
            },
            {
              label: 'Overnight Mailing Address',
              value: props.tradeIn?.payoffMeta?.overnightMailingAddress
                ? fmtAddress(props.tradeIn.payoffMeta.overnightMailingAddress)
                : NA,
            },
          ],
        },
      ],
    },
    {
      rows: [
        {
          columns: [
            {
              label: 'EFT Account Number',
              value: props.tradeIn?.payoffMeta?.eftAccountNumber ?? NA,
            },
            {
              label: 'EFT Routing Number',
              value: props.tradeIn?.payoffMeta?.eftRoutingNumber ?? NA,
            },
          ],
        },
        {
          columns: [
            {
              label: 'EFT State',
              value: props.tradeIn?.payoffMeta?.eftState ?? NA,
            },
            {
              label: 'EFT City',
              value: props.tradeIn?.payoffMeta?.eftCity ?? NA,
            },
          ],
        },
        {
          columns: [
            {
              label: 'EFT Zip Code',
              value: props.tradeIn?.payoffMeta?.eftZipCode ?? NA,
            },
          ],
        },
      ],
    },
  ];

  return (
    <div className="payoff-results-container">
      <Row className="payoff-results-row">
        <div className="payoff-results-header">
          <h3>Trade Payoff Found</h3>
          We found the most accurate trade payoff amount available.
        </div>
      </Row>
      {sections.map(section => (
        <div className="payoff-results-section">
          {section.rows.map(row => (
            <Row className="payoff-results-row">
              {row.columns.map((column, index) => (
                <Col xs={4} xsOffset={index === 0 ? 0 : 3}>
                  <div>
                    <span className="b">{column.label}:</span>
                  </div>
                  {column.value}
                </Col>
              ))}
            </Row>
          ))}
        </div>
      ))}
      <div className="text-center">
        <Button onClick={props.onClose} className="btn modal-button">
          {props.successButtonText || 'Confirm'}
        </Button>
      </div>
    </div>
  );
};
